import React from "react";
import "../../assets/scss/components/generic/checkbox.scss";

export interface ICheckboxProps {
	checked: boolean; // true if checkbox is checked, else false
	name: string; // name for input checkbox
	disabled?: boolean; // if disabled then pass true
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void; // function to be called on change
}

const Checkbox: React.FC<ICheckboxProps> = props => {
	return (
		<label className={"checkbox" + (props.disabled ? " disabled" : "")}>
			<input type="checkbox" onChange={props.onChange} checked={props.checked || false} name={props.name} />
			<span className="checked edel-icon-tick"></span>
			{props.children && <span className="checkbox_label">{props.children}</span>}
		</label>
	);
};

export default Checkbox;
